var ubBanzai = require('ub/control/banzai-features');
var rmElementViewWrappers = ubBanzai.features.isRmElementViewWrappersEnabled();

if (rmElementViewWrappers) {
  // Once we've validated this works in production, we can rm all but cumulativeOffset.
  // It should be moved to visible_element.js
  window.lp.pom.VisibleElementViewWrapperMethods = {
    cumulativeOffset: function() {
      return this.view.cumulativeOffset();
    },
    setWidth: function() {
      throw new Error('deprecated setWidth: ' + this.id);
      //this.view.setWidth(v, unit);
    },

    setHeight: function() {
      throw new Error('deprecated setSize: ' + this.id);
      //this.view.setHeight(v, unit);
    },

    setSize: function() {
      throw new Error('deprecated setSize: ' + this.id);
      //this.view.setSize(v, unit);
    },

    setLeft: function() {
      throw new Error('deprecated setLeft: ' + this.id);
      //this.view.setLeft(v);
    },

    setTop: function() {
      throw new Error('deprecated setTop: ' + this.id);
      //this.view.setTop(v);
    },

    setOffset: function() {
      throw new Error('deprecated setOffset: ' + this.id);
      //this.view.setOffset(v);
    },

    getWidth: function() {
      throw new Error('deprecated getWidth: ' + this.id);
      //return this.view.getWidth();
    },

    getHeight: function() {
      throw new Error('deprecated getHeight: ' + this.id);
      //return this.view.getHeight();
    },

    getLeft: function() {
      throw new Error('deprecated getLeft: ' + this.id);
      //return this.view.getLeft();
    },

    getTop: function() {
      throw new Error('deprecated getTop: ' + this.id);
      //return this.view.getTop();
    },

    getOffset: function() {
      throw new Error('deprecated getOffset: ' + this.id);
      //return this.view.getOffset();
    },

    visible: function() {
      throw new Error('deprecated visible: ' + this.id);
      //return this.view.visible();
    },

    insert: function() {
      throw new Error('deprecated insert '+ this.id);
      //return this.view.insert(elmOrJuiComponent, position);
    },

    update: function() {
      throw new Error('deprecated update: ' + this.id);
      //return this.view.update(content);
    },

    remove: function() {
      throw new Error('deprecated remove: ' + this.id);
      //return this.view.remove();
    }
  };
} else {
  // old behaviour
  window.lp.pom.VisibleElementViewWrapperMethods = {
    cumulativeOffset: function() {
      return this.view.cumulativeOffset();
    },

    setWidth: function(v, unit) {
      this.view.setWidth(v, unit);
    },

    setHeight: function(v, unit) {
      this.view.setHeight(v, unit);
    },

    setSize: function(v, unit) {
      this.view.setSize(v, unit);
    },

    setLeft: function(v) {
      this.view.setLeft(v);
    },

    setTop: function(v) {
      this.view.setTop(v);
    },

    setOffset: function(v) {
      this.view.setOffset(v);
    },

    getWidth: function() {
      return this.view.getWidth();
    },

    getHeight: function() {
      return this.view.getHeight();
    },

    getLeft: function() {
      return this.view.getLeft();
    },

    getTop: function() {
      return this.view.getTop();
    },

    getOffset: function() {
      return this.view.getOffset();
    },

    visible: function() {
      return this.view.visible();
    },

    insert: function(elmOrJuiComponent, position) {
      return this.view.insert(elmOrJuiComponent, position);
    },

    update: function(content) {
      return this.view.update(content);
    },

    remove: function() {
      return this.view.remove();
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/visible_element_view_wrapper_methods.js
// module id = 466
// module chunks = 0 1